export const TRANSLATE_PREFIX = 'STATIC.PAGES.ACCOUNT_TYPE_WIZARD';
export const PARTNER_PATH = '/react/partner-signup/#/react/partner-signup';
export const AGENCY_PATH = '/react/agency-signup/#/react/agency-signup';
export const WIZARD_SESSION_KEY = 'accountTypeWizardAnswers';
